import L from "leaflet";
import "leaflet/dist/leaflet.css";

// Numbered / coloured pin as a div icon (no external marker asset needed).
export function pinIcon(label, color = "#0284C7", size = 30) {
  return L.divIcon({
    className: "ep-pin",
    html: `<div style="background:${color};width:${size}px;height:${size}px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);display:flex;align-items:center;justify-content:center;box-shadow:0 2px 6px rgba(0,0,0,.35);border:2px solid #fff;">
             <span style="transform:rotate(45deg);color:#fff;font-size:12px;font-weight:700;font-family:system-ui;">${label}</span>
           </div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size],
  });
}

export function dotIcon(color = "#111827", size = 26) {
  return L.divIcon({
    className: "ep-dot",
    html: `<div style="background:${color};width:${size}px;height:${size}px;border-radius:50%;display:flex;align-items:center;justify-content:center;box-shadow:0 0 0 4px ${color}33;border:2px solid #fff;">
             <span style="color:#fff;font-size:13px;">🚚</span>
           </div>`,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
  });
}

export { L };

// Keep Leaflet panes/controls below app modals & overlays.
if (typeof document !== "undefined" && !document.getElementById("ep-leaflet-z")) {
  const st = document.createElement("style");
  st.id = "ep-leaflet-z";
  st.innerHTML = ".leaflet-container{z-index:0;isolation:isolate}.leaflet-pane,.leaflet-top,.leaflet-bottom{z-index:1}";
  document.head.appendChild(st);
}
